import { v7 as uuidv7 } from "uuid";
import { z } from "zod";

export const officeSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  createdAt: z.coerce.date().default(new Date()),
  updatedAt: z.coerce.date().default(new Date()),
});

export const newOfficeInputSchema = officeSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});

export type Office = z.infer<typeof officeSchema>;
export type OfficeInput = z.input<typeof officeSchema>;
export type NewOfficeInput = z.input<typeof newOfficeInputSchema>;

export const getOfficeSchema = officeSchema.extend({
  itemId: z.string().uuid(),
});

export const createOffice = (input: NewOfficeInput): Office => {
  return newOffice({
    ...input,
    id: uuidv7(),
  });
};

export const newOffice = (input: OfficeInput): Office => officeSchema.parse(input);
